import classNames from "classnames";
import * as React from "react";
import Select, { components } from "react-select";
import Tick from "@assets/images/tick.svg";

type Option = { value: string; label: string };

type SelectV2Props = {
  label?: string;
  errorMsg?: string | null;
  className?: string;
  options: Array<Option>;
  value?: Option;
  onChange?: (value: Option) => void;
};

const CustomSingleValue = (props: any) => {
  return <components.SingleValue {...props} />;
};

const CustomOption = (props: any) => {
  const { data, isSelected, innerRef, innerProps } = props;
  return (
    <div
      ref={innerRef}
      {...innerProps}
      className={classNames(
        "flex items-center justify-between px-4 py-3 cursor-pointer",
        isSelected ? "font-semibold" : "text-gray-900",
        "hover:bg-gray-100"
      )}
    >
      <span>{data.label}</span>
      {isSelected && <Tick />}
    </div>
  );
};

export const SelectV2 = ({
  label,
  errorMsg,
  className,
  options,
  value,
  onChange,
  ...restProps
}: SelectV2Props): JSX.Element => {
  const customStyles = {
    control: (base: any, state: any) => ({
      ...base,
      backgroundColor: "white",
      border: errorMsg ? "2px solid #EF4444" : "1px solid #E4E4E4",
      borderRadius: "8px",
      padding: "6px",
      boxShadow: "none",
      "&:hover": {
        borderColor: state.isFocused ? "#2563EB" : "#E4E4E4",
      },
    }),
    menu: (base: any) => ({
      ...base,
      borderRadius: "8px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      zIndex: 2,
    }),
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "#2563EB" : "white",
      color: state.isSelected ? "white" : "#333",
      "&:hover": {
        backgroundColor: "#2563EB",
        color: "white",
      },
    }),
  };

  return (
    <div className={classNames("flex flex-col", className)}>
      {label && (
        <div className="text-[16px] normal-case font-semibold mb-4">
          {label}
        </div>
      )}
      <Select
        components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
        styles={customStyles}
        className="w-full"
        options={options}
        value={value}
        onChange={onChange}
        {...restProps}
      />
      {errorMsg && <p className="text-red-500 text-sm mt-1">{errorMsg}</p>}
    </div>
  );
};

export default React.memo(SelectV2);
